/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetStationFormOptionsResponse,
  GetStationResponse,
  ListRequest,
  ListResponseOfStationCountrySuggestion,
  ListResponseOfStationDestinationSuggestion,
  ListResponseOfStationListItem,
  ListResponseOfStationSuggestion,
  StationWriteRequest
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const createProductsStation = (
    stationWriteRequest: StationWriteRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/products/stations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stationWriteRequest, signal
    },
      );
    }
  


export const getCreateProductsStationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductsStation>>, TError,{data: StationWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProductsStation>>, TError,{data: StationWriteRequest}, TContext> => {

const mutationKey = ['createProductsStation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductsStation>>, {data: StationWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  createProductsStation(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProductsStationMutationResult = NonNullable<Awaited<ReturnType<typeof createProductsStation>>>
    export type CreateProductsStationMutationBody = StationWriteRequest
    export type CreateProductsStationMutationError = ErrorType<unknown>

    export const useCreateProductsStation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductsStation>>, TError,{data: StationWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProductsStation>>,
        TError,
        {data: StationWriteRequest},
        TContext
      > => {

      const mutationOptions = getCreateProductsStationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getProductsStationCountrySuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfStationCountrySuggestion>(
      {url: `/api/products/stations/countries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetProductsStationCountrySuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProductsStationCountrySuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getProductsStationCountrySuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getProductsStationCountrySuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getProductsStationCountrySuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getProductsStationCountrySuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetProductsStationCountrySuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getProductsStationCountrySuggestions>>>
    export type GetProductsStationCountrySuggestionsMutationBody = ListRequest
    export type GetProductsStationCountrySuggestionsMutationError = ErrorType<unknown>

    export const useGetProductsStationCountrySuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProductsStationCountrySuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getProductsStationCountrySuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetProductsStationCountrySuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getProductsStationDestinationSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfStationDestinationSuggestion>(
      {url: `/api/products/stations/destinations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetProductsStationDestinationSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProductsStationDestinationSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getProductsStationDestinationSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getProductsStationDestinationSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getProductsStationDestinationSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getProductsStationDestinationSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetProductsStationDestinationSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getProductsStationDestinationSuggestions>>>
    export type GetProductsStationDestinationSuggestionsMutationBody = ListRequest
    export type GetProductsStationDestinationSuggestionsMutationError = ErrorType<unknown>

    export const useGetProductsStationDestinationSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProductsStationDestinationSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getProductsStationDestinationSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetProductsStationDestinationSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getProductsStationFormOptions = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetStationFormOptionsResponse>(
      {url: `/api/products/stations/form-options`, method: 'GET', signal
    },
      );
    }
  



export const getGetProductsStationFormOptionsQueryKey = () => {
    return [
    `/api/products/stations/form-options`
    ] as const;
    }

    
export const getGetProductsStationFormOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getProductsStationFormOptions>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStationFormOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsStationFormOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsStationFormOptions>>> = ({ signal }) => getProductsStationFormOptions(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsStationFormOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsStationFormOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsStationFormOptions>>>
export type GetProductsStationFormOptionsQueryError = ErrorType<unknown>


export function useGetProductsStationFormOptions<TData = Awaited<ReturnType<typeof getProductsStationFormOptions>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStationFormOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsStationFormOptions>>,
          TError,
          Awaited<ReturnType<typeof getProductsStationFormOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsStationFormOptions<TData = Awaited<ReturnType<typeof getProductsStationFormOptions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStationFormOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsStationFormOptions>>,
          TError,
          Awaited<ReturnType<typeof getProductsStationFormOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsStationFormOptions<TData = Awaited<ReturnType<typeof getProductsStationFormOptions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStationFormOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductsStationFormOptions<TData = Awaited<ReturnType<typeof getProductsStationFormOptions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStationFormOptions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductsStationFormOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const productsStationList = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfStationListItem>(
      {url: `/api/products/stations/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getProductsStationListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsStationList>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof productsStationList>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['productsStationList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsStationList>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  productsStationList(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsStationListMutationResult = NonNullable<Awaited<ReturnType<typeof productsStationList>>>
    export type ProductsStationListMutationBody = ListRequest
    export type ProductsStationListMutationError = ErrorType<unknown>

    export const useProductsStationList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsStationList>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productsStationList>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getProductsStationListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getProductsStationSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfStationSuggestion>(
      {url: `/api/products/stations/suggestions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetProductsStationSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProductsStationSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getProductsStationSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getProductsStationSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getProductsStationSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getProductsStationSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetProductsStationSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getProductsStationSuggestions>>>
    export type GetProductsStationSuggestionsMutationBody = ListRequest
    export type GetProductsStationSuggestionsMutationError = ErrorType<unknown>

    export const useGetProductsStationSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProductsStationSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getProductsStationSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetProductsStationSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateProductsStation = (
    id: number,
    stationWriteRequest: StationWriteRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/products/stations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: stationWriteRequest
    },
      );
    }
  


export const getUpdateProductsStationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductsStation>>, TError,{id: number;data: StationWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProductsStation>>, TError,{id: number;data: StationWriteRequest}, TContext> => {

const mutationKey = ['updateProductsStation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductsStation>>, {id: number;data: StationWriteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProductsStation(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductsStationMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductsStation>>>
    export type UpdateProductsStationMutationBody = StationWriteRequest
    export type UpdateProductsStationMutationError = ErrorType<unknown>

    export const useUpdateProductsStation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductsStation>>, TError,{id: number;data: StationWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProductsStation>>,
        TError,
        {id: number;data: StationWriteRequest},
        TContext
      > => {

      const mutationOptions = getUpdateProductsStationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getProductsStation = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetStationResponse>(
      {url: `/api/products/stations/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetProductsStationQueryKey = (id?: number,) => {
    return [
    `/api/products/stations/${id}`
    ] as const;
    }

    
export const getGetProductsStationQueryOptions = <TData = Awaited<ReturnType<typeof getProductsStation>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsStationQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsStation>>> = ({ signal }) => getProductsStation(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsStation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsStationQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsStation>>>
export type GetProductsStationQueryError = ErrorType<void>


export function useGetProductsStation<TData = Awaited<ReturnType<typeof getProductsStation>>, TError = ErrorType<void>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsStation>>,
          TError,
          Awaited<ReturnType<typeof getProductsStation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsStation<TData = Awaited<ReturnType<typeof getProductsStation>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsStation>>,
          TError,
          Awaited<ReturnType<typeof getProductsStation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsStation<TData = Awaited<ReturnType<typeof getProductsStation>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductsStation<TData = Awaited<ReturnType<typeof getProductsStation>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStation>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductsStationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteProductsStation = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/products/stations/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProductsStationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductsStation>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductsStation>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteProductsStation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductsStation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductsStation(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductsStationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductsStation>>>
    
    export type DeleteProductsStationMutationError = ErrorType<unknown>

    export const useDeleteProductsStation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductsStation>>, TError,{id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductsStation>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteProductsStationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    